import { Mail, Phone, MapPin, Globe } from 'lucide-react'

function Footer() {
  return (
    <footer className="bg-apple-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-semibold mb-4">EcoBag Pro</h3>
            <p className="text-apple-gray-400 leading-relaxed mb-6 max-w-md">
              Professional nonwoven bag manufacturer committed to providing premium custom packaging 
              solutions for brands worldwide. Quality, sustainability, and innovation drive everything we do.
            </p>
            <div className="flex items-center gap-2 text-apple-gray-400 text-sm">
              <Globe size={16} />
              <span>Serving customers globally</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="#home" className="text-apple-gray-400 hover:text-white transition-colors text-sm">Home</a></li>
              <li><a href="#about" className="text-apple-gray-400 hover:text-white transition-colors text-sm">About Us</a></li>
              <li><a href="#products" className="text-apple-gray-400 hover:text-white transition-colors text-sm">Products</a></li>
              <li><a href="#quote" className="text-apple-gray-400 hover:text-white transition-colors text-sm">Get Quote</a></li>
              <li><a href="#blog" className="text-apple-gray-400 hover:text-white transition-colors text-sm">Blog</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-apple-gray-400 text-sm">
                <Mail size={16} className="mt-0.5 flex-shrink-0" />
                <span>info@ecobagpro.com</span>
              </li>
              <li className="flex items-start gap-2 text-apple-gray-400 text-sm">
                <Phone size={16} className="mt-0.5 flex-shrink-0" />
                <span>+86 123 4567 8900</span>
              </li>
              <li className="flex items-start gap-2 text-apple-gray-400 text-sm">
                <MapPin size={16} className="mt-0.5 flex-shrink-0" />
                <span>Manufacturing Base, China</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-apple-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-apple-gray-500 text-sm">
              © 2024 EcoBag Pro. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-apple-gray-500 hover:text-white text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-apple-gray-500 hover:text-white text-sm transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
